import { Slider } from "@mui/material";


export default function SliderField ({ label, value, onHandleStyleChange, type='px' }) {

    const formattedValue = (value_) => {
        return Number(value_.toString().replace(type, ''));
    }

    return (
        <div>
            <label>{label} ({value})</label>
            <Slider
                size="small"
                defaultValue={formattedValue(value)}
                aria-label="Small"
                valueLabelDisplay="auto"
                onChange={(e)=>onHandleStyleChange(e.target.value+type)}
            />
        </div>
    )
};